import { render, staticRenderFns } from "./SuggestionPage2.vue?vue&type=template&id=e9f3533c"
import script from "./SuggestionPage2.vue?vue&type=script&lang=js"
export * from "./SuggestionPage2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports